import { useEffect, useState, type FormEvent } from "react";
import { api, ApiError } from "../lib/api";
import { Mark } from "../components/primitives";

interface Config {
  devLogin: boolean;
  roblox: boolean;
  people: { handle: string; name: string }[];
}

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [config, setConfig] = useState<Config | null>(null);
  const [handle, setHandle] = useState("");
  const [error, setError] = useState(new URLSearchParams(location.search).get("error") ?? "");
  useEffect(() => {
    document.title = "Sign in · melo.build";
    fetch("/auth/config")
      .then((r) => r.json())
      .then(setConfig, () => setError("Can't reach melo.build. Check your connection."));
  }, []);
  const dev = async (h: string, e?: FormEvent) => {
    e?.preventDefault();
    try {
      await api.post("/auth/dev", { handle: h });
      history.replaceState(null, "", "/");
      onSignedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Sign-in failed.");
    }
  };
  return (
    <main className="signin">
      <div className="signin-card">
        <Mark />
        <div>
          <h1>melo.build</h1>
          <p style={{ marginTop: 8 }}>Plan, concept and ship Melo games with your team and your agents.</p>
        </div>
        {error && (
          <p className="error-text" role="alert">
            {error}
          </p>
        )}
        {config?.roblox && (
          <a className="btn pri big-btn" href={`/auth/roblox/start?returnTo=${encodeURIComponent(new URLSearchParams(location.search).get("returnTo") ?? "/")}`}>
            Sign in with Roblox
          </a>
        )}
        {config && !config.roblox && !config.devLogin && <p className="hint">Sign-in is not set up on this server yet.</p>}
        {config?.devLogin && (
          <div className="block">
            <div className="block-h">
              <h3>Developer sign-in</h3>
              <span className="muted">Local only</span>
            </div>
            {config.people.map((p) => (
              <button key={p.handle} type="button" className="row" onClick={() => void dev(p.handle)}>
                <span className="t">
                  <span>{p.name}</span>
                  <small>@{p.handle}</small>
                </span>
              </button>
            ))}
            <form className="row" onSubmit={(e) => void dev(handle, e)}>
              <input className="input" placeholder="New handle" value={handle} onChange={(e) => setHandle(e.target.value.toLowerCase())} aria-label="Handle" />
              <button type="submit" className="btn" disabled={handle.length < 2}>
                Continue
              </button>
            </form>
          </div>
        )}
      </div>
    </main>
  );
}
